var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Box } from '@mui/material';
import styled from 'styled-components';
export var RoundBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  margin-right: 10px;\n  margin-left: 10px;\n  margin-top: 30px;\n"], ["\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  margin-right: 10px;\n  margin-left: 10px;\n  margin-top: 30px;\n"])));
var templateObject_1;
